export const validateMaxValue = (value: number, maxValue: number) => {
    if (value && value > maxValue) {
        return `The maximum value allowed is ${maxValue}`
    }
    return undefined
}
